import { AfterViewInit, Component } from '@angular/core';
import { FormGroupState } from 'ngrx-forms';
import { Observable } from 'rxjs/index';
import { AdminSystemSettingsActions } from './state/admin-system-settings-actions.service';
import { AdminSystemSettingsSelectors } from './state/admin-system-settings-selectors.service';
import { SystemSettingsFormValue } from './state/admin-system-settings.state';

@Component({
    selector: 'admin-system-component',
    templateUrl: './admin-system.component.html',
    styleUrls: ['./admin-system.component.css']
})
export class AdminSystemComponent implements AfterViewInit {

    public loading$: Observable<boolean>;
    formState$: Observable<FormGroupState<SystemSettingsFormValue>>;

    constructor(
        private systemSettingsSelectors: AdminSystemSettingsSelectors,
        private systemSettingsActions: AdminSystemSettingsActions) {
        // Setup state selectors
        this.formState$ = systemSettingsSelectors.selectFormState();
        this.loading$ = systemSettingsSelectors.selectLoadingStatus();
    }

    ngAfterViewInit(): void {
        this.systemSettingsActions.getSystemSettingsFromAdmin(undefined);
        // TODO: Combine into new stream getting formState and settings when user ready - to avoid subscriptions
    }

    saveSettings(): void {
        this.systemSettingsActions.saveSystemSettings(undefined);
    }

}
